var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Logos2',{attrs:{"title":"Certificates","logos":_vm.logos}})
}
var staticRenderFns = []

export { render, staticRenderFns }